import * as actionTypes from '../constants/actionType';
import * as apiActions from "./apiActions";
import * as apiValues from "../constants/apiValues";
import * as carouselSlideActions from './carouselSlideActions';
//import {getMCarouselById} from "../reducers/index";


//Action Creators
export const loadMCarouselStart = (id) => {
  return {
    type: actionTypes.MCAROUSEL_LOAD_START,
    id
  };
};
export const loadMCarouselFail = (id, error) => {
  console.error(error);
  return {
    type: actionTypes.MCAROUSEL_LOAD_FAIL,
    id,
    error
  };
};
export const loadMCarouselSuccess = (data) => {
  return {
    type: actionTypes.MCAROUSEL_LOAD_SUCCESS,
    data
  };
};

export const initMCarousel = () => dispatch => {
  dispatch(loadMCarouselStart());

  apiActions
    .loadSingleType(apiValues.nref.mCarousel.endpoint)
    .then((result) => {
      const carouselDocId = result.documentId || result.id;
      const normalized = apiActions.itemSelectCamelCaseKeys(result, apiValues.nref.mCarousel.fieldsUsed);

      const finishSlides = (slideRows) => {
        const carouselSlides = apiActions.arraySelectCamelCaseKeys(
          slideRows || [],
          apiValues.nref.carouselSlide.fieldsUsed
        );
        carouselSlides.forEach((carouselSlide) => {
          dispatch(carouselSlideActions.loadCarouselSlideSuccess(carouselSlide));
        });
        normalized.carouselSlides = carouselSlides.map((carouselSlide) => carouselSlide.id);
        dispatch(loadMCarouselSuccess(normalized));
      };

      if ((normalized.carouselSlides || []).length > 0) {
        return finishSlides(normalized.carouselSlides);
      }
      return apiActions
        .loadInverseRelationList(apiValues.nref.carouselSlide.endpoint, 'mCarousels', carouselDocId)
        .then((list) => finishSlides(list || []));
    })
    .catch((err) => dispatch(loadMCarouselFail(err)));
};


